import React from "react";
import styles from "./groupDataEdit.module.css"
import { MdOutlineCheck, MdOutlineClose, MdOutlineEdit } from "react-icons/md";
import CircleLoading from "../../../CircleLoading";

const GroupDataEdit = ({ name, value, edit = false, loading = false, loadingText = "Salvando...", borderTop = true, onChangeEdit = () => { }, onCancelEdit = () => { }, onUpdate = () => { }, showActions = true, children }) => {
    return (
        <div className={`${styles.groupItem} ${borderTop ? styles.borderTop : ''} ${loading ? styles.loading : ''}`} aria-busy={loading}>
            {showActions && !loading &&
                <div className={styles.actions}>
                    {edit ?
                        <>
                            <MdOutlineCheck onClick={() => onUpdate(name, { [name]: value })} />
                            <MdOutlineClose onClick={() => onCancelEdit(name)} />
                        </>
                        :
                        <MdOutlineEdit onClick={() => onChangeEdit(name, true)} />
                    }

                </div>
            }
            {children}
            {loading &&
                <div className={styles.loadingOverlay} role="status" aria-live="polite">
                    <CircleLoading className={styles.loadingIndicator} />
                    <span>{loadingText}</span>
                </div>
            }
        </div>
    )
}

export default GroupDataEdit
